// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Anchor-styles-module--wrapper--2R_tQ","anchor":"Anchor-styles-module--anchor--2zQH2"};